module.exports = __webpack_public_path__ + "kg.svg?0e8c2a1deb7a97d5d6fae34edf6fffe0";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/kg.svg
// module id = 1185
// module chunks = 0